<div *ngIf="inited">
    <sm-toolbar>
        <p-button icon="fas fa-save" label="Speichern" [disabled]="!isChanged()" (onClick)="save()">
        </p-button>
    </sm-toolbar>
    <sm-table [data]="table" [deltaHeight]=150 [allowExport]="false">
    </sm-table>
</div>
